import { t } from "@lingui/macro";
import { UiBox } from "@smp/ui";
import { MapRecord } from "@smp/utils";
import {
  IconAspectRatio,
  IconLayoutCollage,
  IconPlant2,
} from "@tabler/icons-react";
import { FC, useMemo } from "react";

import {
  FilterGroupWrapper,
  FilterOptionButton,
} from "@/components/features/polotno_templates/screens/filters/components/_shared";
import { useSmpAgTranslation } from "@/hooks/use_smp_ag_translation";
import { useQueryPolotnoTagsAll } from "@/queries/polotno/use_query_polotno_tags_all";

import { useContextStickers } from "../../../../context";

export const CommonTagSelector: FC<{
  group: MapRecord<
    ReturnType<typeof useQueryPolotnoTagsAll>["data"]["grouped"]
  >;
}> = ({ group }) => {
  const getTranslation = useSmpAgTranslation();

  const {
    actions: { updateSelectedTags },
    state: { selectedTags },
  } = useContextStickers();

  const isAllActive = useMemo(
    () =>
      Boolean(group && !selectedTags.some((tag) => tag.startsWith(group.slug))),
    [group, selectedTags],
  );

  if (!group?.children.length) {
    return null;
  }

  return (
    <FilterGroupWrapper
      icon={
        {
          category: <IconLayoutCollage />,
          type: <IconAspectRatio />,
          theme: <IconPlant2 />,
        }[group.slug]
      }
      title={getTranslation(group.name)}
    >
      <UiBox display="flex" flexWrap="wrap" gap={1}>
        <FilterOptionButton
          key="all"
          isActive={isAllActive}
          value="all"
          title={t`Show all`}
          onChange={() => updateSelectedTags(group.slug, undefined)}
        />
        {group.children.map((tag) => (
          <FilterOptionButton
            key={tag.slug}
            isActive={selectedTags.includes(tag.slug)}
            value={tag.slug}
            title={getTranslation(tag.translations)}
            onChange={() => updateSelectedTags(group.slug, tag.slug)}
          />
        ))}
      </UiBox>
    </FilterGroupWrapper>
  );
};
